import { render, staticRenderFns } from "./CarouselEl.vue?vue&type=template&id=01b795f2&scoped=true&"
import script from "./CarouselEl.vue?vue&type=script&lang=ts&"
export * from "./CarouselEl.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselEl.vue?vue&type=style&index=0&id=01b795f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b795f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCarousel,VCarouselItem,VIcon})
